import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "eye_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15 12a3 3 0 1 1-6 0h3V9a3 3 0 0 1 3 3Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M23 12s-2.5 8-11 8-11-8-11-8 2.5-8 11-8 11 8 11 8Zm-6 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }